import { promiseFetch } from '@accedo/promise-fetch';
import { logger } from '@accedo/logger';
import { sendApiRequestWithFwResponse } from '../apirequest';
import { FwApiPlaybackResponse } from '../playback/types';
import {
  LiveDAIAdResponse,
  LiveDAIResponse,
  VODPlaybackResponse,
} from './types';

export const getLivePlaybackData = async (
  assetKey: string,
  postBody: string,
): Promise<LiveDAIResponse> => {
  const daiUrl = `https://dai.google.com/linear/v1/hls/event/${assetKey}/stream`;
  return promiseFetch(daiUrl, {
    method: 'POST',
    headers: {
      'content-type': 'application/x-www-form-urlencoded',
    },
    data: postBody,
  }).then((res) => res.data);
};

export const getPlaybackInfo = async (
  apiEndpoint: string,
  headers: object,
  isFreeWheelEnabled = false
): Promise<FwApiPlaybackResponse> =>
  sendApiRequestWithFwResponse<FwApiPlaybackResponse>(
    `${apiEndpoint}?platform=hbbtv`,
    'GET',
    headers,
    isFreeWheelEnabled
  );

export const getVodPlaybackData = async (
  videoId: string,
  contentSourceId: string,
  postBody: string,
): Promise<VODPlaybackResponse> => {
  const daiUrl = `https://dai.google.com/ondemand/v1/dash/content/${contentSourceId}/vid/${videoId}/stream`;
  return promiseFetch(daiUrl, {
    method: 'POST',
    headers: {
      'content-type': 'application/x-www-form-urlencoded',
    },
    data: postBody,
  }).then((res) => res.data);
};

export const sendTrackingEvent = async (
  verificationUrl: string,
  eventId: string,
): Promise<void> => {
  if (!verificationUrl || !eventId) {
    Promise.reject(new Error('No verification url or tracking id'));
  } else {
    logger.info('[Dai.ts] ad tracking event request...');
    await promiseFetch(`${verificationUrl}${eventId}`);
  }
};

export const getAdBreaks = async (
  metadataUrl: string,
): Promise<LiveDAIAdResponse> =>
  promiseFetch(metadataUrl).then((res) => res.data);
